import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { UserPermissionsService } from '../../services/user-permissions.service';
import { Observable, Subscription } from 'rxjs';

interface Tab {
  data?: any;
  allowed: boolean;
  permissions?: any[];
  id: string | null;
  path?: string;
  parent: any;
  active?: boolean;
  title?: string;
  icon?: string;
}
@Component({
    selector: 'top-bar-tabs',
    templateUrl: './top-bar-tabs.component.html',
    styleUrls: ['./top-bar-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopBarTabsComponent implements OnInit {
  public tabs: Tab[] = [];
  private permsSub: Subscription;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userPermissionsService: UserPermissionsService
  ) {
    if (route.parent?.routeConfig?.children) {
      for (
        let i: number = 0;
        i < route.parent?.routeConfig?.children?.length;
        i += 1
      ) {
        if (route.parent.routeConfig.children[i].data) {
          this.tabs[i] = {
            data: route.parent.routeConfig.children[i].data,
            allowed:
              !route.parent.routeConfig.children[i].data?.['permissions']
                ?.length,
            permissions:
              route.parent.routeConfig.children[i].data?.['permissions'],
            id: route.snapshot.paramMap.get('id'),
            path: route.parent.routeConfig.children[i].path?.substring(
              0,
              route.parent.routeConfig.children[i].path?.indexOf('/')
            ),
            parent: route.parent.snapshot.routeConfig?.path,
          };
          if (this.tabs[i].path?.length === 0) {
            this.tabs[i].path = route.parent.routeConfig.children[i].path;
          }
          this.tabs[i].title = this.tabs[i].data['tab'];
          this.tabs[i].icon = this.tabs[i].data['icon'];
          if (
            this.tabs[i].path ===
              route.routeConfig?.path?.substring(
                0,
                route.routeConfig?.path?.indexOf('/')
              ) ||
            this.tabs[i].path === route.routeConfig?.path
          ) {
            this.tabs[i].active = true;
          } else {
            this.tabs[i].active = false;
          }
          this.tabs[i].path = this.tabs[i].path?.replace(':id', '');
          this.fetchPermissions(this.tabs[i].data?.permissions);
          delete this.tabs[i].data;
        }
      }
      this.permsSub = this.userPermissionsService.$userPerms.subscribe(() => {
        for (let i = 0; i < this.tabs.length; i++) {
          let tab = this.tabs[i];
          if (!tab.allowed && tab.permissions?.length) {
            for (let j = 0; j < tab.permissions.length; j++) {
              let perm = tab.permissions[j];
              if (
                this.userPermissionsService.userPerms[perm.type]?.[
                  tab.id ?? '_'
                ]?.[perm.verb] ||
                this.userPermissionsService.userPerms[perm.type]?.['_']?.[
                  perm.verb
                ]
              ) {
                this.tabs[i].allowed = true;
              }
            }
          }
        }
      });
    }
  }
  private fetchPermissions(permissions?: any[]): void {
    if (permissions?.length) {
      for (let i = 0; i < permissions.length; i++) {
        this.userPermissionsService.getUserPermissions(
          permissions[i].type.toUpperCase(),
          this.route.snapshot.paramMap.get('id')
        );
      }
    }
  }
  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.permsSub && this.permsSub.unsubscribe();
  }
}
